import { Pipe, PipeTransform } from '@angular/core';

import { RestUserModel } from '@shared/interfaces/user.interface';

@Pipe({
  name: 'usernameById',
})
export class UsernameByIdPipe implements PipeTransform {
  transform(assigneeId: number, users: RestUserModel[]): string {
    if (!assigneeId || !users?.length) {
      return '';
    }
    const user = users.find(u => u.id === assigneeId);
    if (user) {
      return user.displayName;
    }
    return '';
  }
}
